// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import appActions from '../../../actions/appActions';
import { activeMapSourceSelector } from '../../../selectors/configSelectors';
import { throttlingIntervalSelector } from '../../../selectors/appSelectors';
import { drawingSelector } from '../../../selectors/zoneSelectors';
import Map from '../Map';
import type { Props } from '../Map';

const mapStateToProps = (state: State) => {
    return {
        mapSource: activeMapSourceSelector(state),
        drawingEnabled: Boolean(drawingSelector(state)),
        throttlingInterval: throttlingIntervalSelector(state)
    };
};

const mapDispatchToProps = {
    hideSidebar: () => appActions.setSection(null),
    setThrottlingInterval: appActions.setThrottlingInterval
};

export default connect<Props, *, _, _, _, _>(mapStateToProps, mapDispatchToProps)(Map);